import type { IModule } from "redux-dynamic-modules-core";
import { requestSlice } from "./requests.slice";


export function RequestModule(): IModule<any>[] {
  return [
    {
      id: requestSlice.reducerPath,
      reducerMap: {
        [requestSlice.reducerPath]: requestSlice.reducer,
      },
    }
  ]
}
